import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelRuleTester } from 'Services';
import { RQ_CANCEL_RULE_TEST, RQ_GET_RULE_TEST_RESULTS } from 'Utils';
import { useSelector } from 'react-redux';
import { getUser } from 'Selectors';

type Props = {
    ruleId: string;
    ruleTestId: string | null;
    refetchStatus: Function;
    merchantId: string;
    tenantGroupId: string;
    ruleSetId: string;
};

const useCancelRuleTest = ({ ruleId, ruleTestId, refetchStatus, merchantId, tenantGroupId, ruleSetId }: Props) => {
    const queryClient = useQueryClient();
    const { tenantKey } = useSelector(getUser);
    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([
            RQ_GET_RULE_TEST_RESULTS,
            ruleId,
            tenantKey,
            merchantId,
            tenantGroupId,
            ruleSetId
        ]);
    };

    return useMutation(
        [RQ_CANCEL_RULE_TEST, ruleTestId, tenantGroupId, ruleSetId],
        () => cancelRuleTester(ruleId, merchantId, tenantGroupId, ruleSetId),
        {
            onSuccess: () => {
                refetchStatus();
                defaultSuccessHandler();
            }
        }
    );
};

export default useCancelRuleTest;
